const monsterKillRewards = `

#### How It Works
- With every **Monster Kill Count**, you can **choose a reward**.
- You can **repeat this every day**.

#### Kill Rewards

**Kill 1,000 Monsters**
- 🏆 1x Gasias Blessing Bundle *(Song of Battle, Four-Leafed Clover, World Blessing)*
- 🧚 5x God Mother Fairy's Bottle

**Kill 3,000 Monsters**
- ✨ 10x Deva's Blessing
- 💍 1x Engagement Ring

**Kill 6,000 Monsters**
- 🛡️ 1x Curse of the Guardian
- 🦴 1x Creatures Hunting
- 🎯 1x Bull's-eye

**Kill 10,000 Monsters**
- 🔮 5x T-Protect Mirror
- 📦 2x Altered Pieces Bundle *(Enhanced)*

**Kill 16,000 Monsters**
- 🛠️ 2x E-Repair Powder
- 🎫 1 Day Premium Pass
- 📜 5x Ancient Cube - Skill
- 🔨 1x Master's Hammer
- ⚡ 5x Energy of Gold *(Enhanced)*

**Kill 25,000 Monsters**
- 📦 1x Mystic Cube - Skill
- 🏅 Title: *Monster Slayer* (**4% Luck**)

**Kill 35,000 Monsters**
- 🎭 1x Ultimate Helmet Cube
- 🛡️ 1x Ultimate Armor Cube
- 🧤 1x Ultimate Glove Cube
- 👢 1x Ultimate Boot Cube
- ⚔️ 1x Ultimate Weapon Cube
- 🛡️ 1x Ultimate Shield Cube

**Kill 50,000 Monsters**
- 💀 5x Powerful Helmet Cube
- 💀 5x Powerful Armor Cube
- 💀 5x Powerful Glove Cube
- 💀 5x Powerful Boot Cube
- 💀 5x Powerful Weapon Cube
- 💀 5x Powerful Shield Cube
- 🔄 2x Powerful Cube Mixer
- 💎 30x Arcanium
- 🏅 Title: *No Game, No Life* (**10% Luck**)

🔥 *Hunt more monsters and claim your rewards daily!* 🔥`;

export default monsterKillRewards;
